// Ekspor daftar produk (Excel) dari server: GET /export-produk. Filter sama dengan halaman Produk (pencarian, kategori, cabang untuk superadmin);
// yang diekspor SEMUA produk yang cocok, bukan hanya halaman yang sedang tampil.

/** Query string ekspor dari filter halaman Produk. Cabang hanya dikirim untuk superadmin (admin selalu cabangnya sendiri). */
export const buatQueryEkspor = ({ search = '', kategori = '', cabanguuid = '', role = '' } = {}) => {
  const p = new URLSearchParams();
  const cari = String(search || '').trim();
  if (cari) p.append('search', cari);
  if (kategori) p.append('kategoriuuid', kategori);
  if (role === 'superadmin' && cabanguuid) p.append('cabanguuid', cabanguuid);
  const q = p.toString();
  return q ? `?${q}` : '';
};

/** Nama berkas: <awalan>-<cabang>-YYYYMMDD.xlsx (cabang dipangkas jadi huruf/angka/strip). */
const namaBerkas = (awalan, namaCabang, tanggal = new Date()) => {
  const slug = String(namaCabang || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40) || 'semua';
  const d = tanggal instanceof Date ? tanggal : new Date(tanggal);
  const t = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
  return `${awalan}-${slug}-${t}.xlsx`;
};

export const namaBerkasProduk = (namaCabang, tanggal) => namaBerkas('produk', namaCabang, tanggal);
export const namaBerkasKategori = (namaCabang, tanggal) => namaBerkas('kategori', namaCabang, tanggal);

// Blob.text() tidak ada di semua lingkungan (mis. jsdom); FileReader sebagai cadangan.
const bacaTeks = (blob) => (typeof blob.text === 'function'
  ? blob.text()
  : new Promise((selesai, gagal) => { const r = new FileReader(); r.onload = () => selesai(String(r.result)); r.onerror = gagal; r.readAsText(blob); }));

/** Pesan galat dari respons blob (server membalas JSON { message }); cadangan bila bukan JSON. */
export const pesanGalatEkspor = async (error, cadangan = 'Gagal mengekspor') => {
  try {
    const data = error && error.response && error.response.data;
    if (data && (typeof data.text === 'function' || typeof FileReader !== 'undefined') && typeof data.message === 'undefined') {
      const j = JSON.parse(await bacaTeks(data));
      if (j && j.message) return String(j.message);
    } else if (data && data.message) {
      return String(data.message);
    }
  } catch (e) { /* abaikan: pakai cadangan */ }
  return cadangan;
};
